export default "__VITE_ASSET__Cs3mO4El__"